var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "go-content-wrapper gray" },
    [
      _c("div", { staticClass: "go-container mypage sub channels" }, [
        _c("div", { staticClass: "go-layout-wrap" }, [
          _c("div", { staticClass: "go-layout-header" }, [
            _c("div", { staticClass: "go-layout-path" }, [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("my-collection-channel.breadcrumb.my-page"))
                ),
              ]),
              _vm._v(" "),
              _c("i", { staticClass: "go-icon-16 go-icon-chevron-right" }),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("my-collection-channel.title"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "go-layout-title" }, [
              _c(
                "button",
                {
                  staticClass: "btn go-btn-icon",
                  attrs: {
                    type: "button",
                    "data-toggle": "dropdown",
                    "aria-expanded": "false",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.roueToMyPage()
                    },
                  },
                },
                [_c("i", { staticClass: "go-icon-24 go-icon-arrow-left" })]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "go-page-header-type2" }, [
                _c("div", { staticClass: "go-page-title" }, [
                  _vm._v(_vm._s(_vm.$t("my-collection-channel.title"))),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "go-layout-content" },
            [
              _c("collection-channel-tabs", {
                on: { change: _vm.onChangeTabs },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "go-channel-header" },
                [
                  _vm.state.tabSelected == "BLOG"
                    ? _c("collection-channel-type-blog", {
                        attrs: { stats: _vm.state.stats },
                        on: { change: _vm.onChangeSourceChannels },
                      })
                    : _vm.state.tabSelected == "CLOUD"
                    ? _c("collection-channel-type-cloud", {
                        attrs: {
                          "total-items": _vm.totalItems,
                          stats: _vm.state.stats,
                        },
                        on: { change: _vm.onChangeSourceChannels },
                      })
                    : _vm.state.tabSelected == "SOCIAL"
                    ? _c("collection-channel-type-social", {
                        attrs: {
                          "total-items": _vm.totalItems,
                          stats: _vm.state.stats,
                        },
                        on: { change: _vm.onChangeSourceChannels },
                      })
                    : _vm.state.tabSelected == "EMAIL"
                    ? _c("collection-channel-type-email", {
                        attrs: {
                          "total-items": _vm.totalItems,
                          stats: _vm.state.stats,
                        },
                        on: { change: _vm.onChangeSourceChannels },
                      })
                    : _c("collection-channel-type-default", {
                        attrs: { "total-items": _vm.totalItems },
                      }),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-form-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.apiParams.keyword,
                          expression: "apiParams.keyword",
                        },
                      ],
                      staticClass: "go-form-control",
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("global.header.search"),
                      },
                      domProps: { value: _vm.apiParams.keyword },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.apiParams,
                            "keyword",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.state.accountChannels.length === 0 && !_vm.state.loading
                ? _c("div", { staticClass: "go-empty" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("p", { staticClass: "go-info-lead" }, [
                      _vm._v(_vm._s(_vm.$t("my-collection-channel.noResults"))),
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      staticClass: "go-info-text",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("my-collection-channel.searchNoResultsText")
                        ),
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("collection-channel-views", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.state.loading,
                    expression: "!state.loading",
                  },
                ],
                attrs: { "account-channels": _vm.state.accountChannels },
                on: {
                  "account:change": _vm.onChangeAccountConfirm,
                  "account:unlink": _vm.onUnlinkAccountConfirm,
                  "agent:update": _vm.onUpdateAgent,
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.state.loading,
                      expression: "state.loading",
                    },
                  ],
                  staticClass: "go-loading-wrap",
                },
                [_c("go-loading")],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.totalItems > _vm.state.pagination.pageSize
            ? _c(
                "div",
                { staticClass: "go-layout-footer" },
                [
                  _c("go-pagination", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.state.loading,
                        expression: "!state.loading",
                      },
                    ],
                    attrs: {
                      "current-page": _vm.state.pagination.currentPage,
                      "total-pages": Math.ceil(
                        _vm.totalItems / _vm.state.pagination.pageSize
                      ),
                    },
                    on: { "change-page": _vm.onPageChange },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("channel-confirm-modal", {
        attrs: {
          open: _vm.state.channelModifyConfirmModal.open,
          "agent-channels": _vm.state.channelModifyConfirmModal.agentChannels,
          title: _vm.$t(
            "my-collection-channel.modal.confirm.change-account.title"
          ),
          description: _vm.$t(
            "my-collection-channel.modal.confirm.change-account.description"
          ),
          "warning-message": _vm.$t(
            "my-collection-channel.modal.confirm.change-account.warning-message"
          ),
          "ok-text": _vm.$t("global.buttons.continue-update"),
        },
        on: {
          "modal:close": _vm.onChangeAccountConfirmClose,
          "modal:ok": _vm.onChangeAccount,
        },
      }),
      _vm._v(" "),
      _c("channel-confirm-modal", {
        attrs: {
          open: _vm.state.channelDeleteConfirmModal.open,
          "agent-channels": _vm.state.channelDeleteConfirmModal.agentChannels,
          title: _vm.$t(
            "my-collection-channel.modal.confirm.unlink-account.title"
          ),
          description: _vm.$t(
            "my-collection-channel.modal.confirm.unlink-account.description"
          ),
          "warning-message": _vm.$t(
            "my-collection-channel.modal.confirm.unlink-account.warning-message"
          ),
          "ok-text": _vm.$t("global.buttons.remove"),
        },
        on: {
          "modal:close": _vm.onUnlinkAccountConfirmClose,
          "modal:ok": _vm.handleUnlinkAccount,
        },
      }),
      _vm._v(" "),
      _c("channel-results-modal", {
        attrs: {
          open: _vm.state.channelAccessResultsModal.open,
          type: _vm.state.channelAccessResultsModal.type,
          title: _vm.state.channelAccessResultsModal.title,
          description: _vm.state.channelAccessResultsModal.description,
        },
        on: { "modal:close": _vm.onAccessResultsClose },
      }),
      _vm._v(" "),
      _c("channel-account-modal", {
        attrs: {
          open: _vm.state.channelAccountModal.open,
          loading: _vm.state.channelAccountModal.loading,
          accounts: _vm.state.channelAccountModal.accounts,
          channelType: _vm.state.channelAccountModal.channelType,
          channelName: _vm.state.channelAccountModal.channelName,
          channelImageUri: _vm.state.channelAccountModal.channelImageUri,
        },
        on: {
          "channel:register": _vm.onRegisterAccount,
          "modal:close": _vm.onChangeAccountClose,
          "modal:ok": _vm.handleChangeAccount,
        },
      }),
      _vm._v(" "),
      _c("channel-login-modal", {
        attrs: {
          open: _vm.state.channelLoginModal.open,
          channelType: _vm.state.channelAccountModal.channelType,
          channelName: _vm.state.channelAccountModal.channelName,
          channelImageUri: _vm.state.channelAccountModal.channelImageUri,
        },
        on: {
          "modal:close": _vm.onRegisterAccountClose,
          "modal:ok": _vm.handleRegisterAccount,
        },
      }),
      _vm._v(" "),
      _c("channel-mode-modal", {
        attrs: {
          open: _vm.state.channelModeModal.open,
          datasource: _vm.state.channelModeModal.datasource,
          channelType: _vm.state.channelModeModal.channelType,
          channelName: _vm.state.channelModeModal.channelName,
          channelImageUri: _vm.state.channelModeModal.channelImageUri,
        },
        on: {
          "modal:close": _vm.onUpdateAgentClose,
          "modal:ok": _vm.handleUpdateAgent,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-icon-wrap" }, [
      _c("i", { staticClass: "go-icon-72 go-icon-search" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }